'use client'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { clickEvent } from '@marketplace-web/complaints/complaints-data'
import { navigateToPage } from '@marketplace-web/browser/browser-navigation-util'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

import { VIEW_ISSUE_DETAILS_URL } from '../../constants/routes'

type Props = Partial<ConversationActionProps> & {
  transactionId?: number
}

const ViewIssueDetails = ({ transactionId, primary, title, inverse, theme, size }: Props) => {
  const { track } = useTracking()

  const trackViewIssueDetailsClick = () => {
    const targetDetails = {
      transaction_id: transactionId,
    }

    track(
      clickEvent({
        target: 'view_issue_details',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  const handleClick = () => {
    if (!transactionId) return

    trackViewIssueDetailsClick()
    navigateToPage(VIEW_ISSUE_DETAILS_URL(transactionId))
  }

  if (!transactionId) return null

  return (
    <ConversationActionButton
      text={title}
      primary={primary}
      size={size}
      theme={theme}
      inverse={inverse}
      onClick={handleClick}
      testId="view-issue-details-action-button"
    />
  )
}

export default ViewIssueDetails
